import { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './HtmlContent.module.css';

import useModal from '../../../hooks/useModal';
import { IModal } from '../../../types/modal';

import SimpleBar from 'simplebar-react';
import useSimpleBar from '../../../hooks/useSimpleBar';

import { apiSlice } from '../../../services/api';

import Modal from '../Modal';
import {
  CLOSE_POPUP,
  EFFECTIVE_DATE,
  PREV,
  PRIVACY_POLICY,
  TERMS,
  VIEW,
} from '../../../constants';

export default function HtmlContent({ id, type, name, data }: IModal) {
  const cx = classNames.bind(styles);
  const { toggleModal } = useModal();
  const closeModal = () => toggleModal({ id, type });
  const [simplebarRef] = useSimpleBar();
  const [isShowPrevTerms, setIsShowPrevTerms] = useState(false);
  const [prevTermsData, setPrevTermsData] = useState<any>('');
  const [getPrevTerms] = apiSlice.useLazyGetPrevTermsQuery();

  const isTerms = name === 'terms' || name === 'privacyPolicy';
  const renderedHtml = {
    __html: isShowPrevTerms
      ? prevTermsData.content
          .replaceAll('--urlSpellingErrorV2,', '')
          .replaceAll('--urlContextualSpellingAndGrammarErrorV2', '')
      : data.content
          .replaceAll('--urlSpellingErrorV2,', '')
          .replaceAll('--urlContextualSpellingAndGrammarErrorV2', ''),
  };

  const showPrevTerms = async () => {
    try {
      const terms = await getPrevTerms(data.agreeCd, true).unwrap();
      setPrevTermsData(terms);
      setIsShowPrevTerms(true);
    } catch (error) {
      console.error('Failed to get previous terms', error);
    }
  };

  return (
    <Modal id={id} type={type} isTerms={isTerms}>
      <div className={cx('top')}>
        <div className={cx('btn_wrap')}>
          <button
            name={CLOSE_POPUP}
            className={cx('pop_close')}
            onClick={closeModal}
          >
            <i className={cx('svg_i')}></i>
          </button>
        </div>
      </div>
      <SimpleBar forceVisible={true} ref={simplebarRef}>
        {isTerms && (
          <div className={cx('info')}>
            {data.prevYn && !isShowPrevTerms ? (
              <button className={cx('prev', 'link_t')} onClick={showPrevTerms}>
                {PREV} {name === 'terms' ? TERMS : PRIVACY_POLICY} {VIEW}
              </button>
            ) : null}
            <span>
              {EFFECTIVE_DATE}:{' '}
              {isShowPrevTerms
                ? prevTermsData.dispStartDate
                : data.dispStartDate}
            </span>
          </div>
        )}

        <div
          className={cx('content_wrap')}
          dangerouslySetInnerHTML={renderedHtml}
        ></div>
      </SimpleBar>
    </Modal>
  );
}
